<button
    class="h-auto border-2 border-green bg-transparent text-base leading-normal text-green transition duration-200 ease-in-out hover:bg-green hover:text-white hover:shadow"
    (click)="accept()">
    {{ text || 'Accept' }}
</button>
